/** Tipurile partajate ale widgetului. Fara logica, ca sa poata fi importate oriunde. */
export interface WidgetConfig {
  storeKey: string;
  apiUrl: string;
  locale: string;
  maxResults: number;
  showPrices: boolean;
  /** Când e setat, widgetul nu-și afișează bara, ci se atașează de inputurile site-ului. */
  hijackSelector: string;
  openSelector?: string;
  cartUrl: string;
  /**
   * Trimite căutările către platformele de analytics găsite în pagină (GA4, Meta
   * Pixel, TikTok, GTM). `off` oprește trimiterea.
   */
  analytics: "auto" | "off";
}

export interface VisualSearchAttributes {
  color?: string[];
  style?: string[];
  pattern?: string[];
  productType?: string[];
}

/** Răspunsul căutării după poză: produsele plus ce a recunoscut AI-ul în imagine. */
export interface VisualSearchResponse extends SearchResponse {
  explanation?: string;
  matchType?: "exact" | "similar" | "none";
  detectedAttributes?: VisualSearchAttributes;
  confidence?: number;
  sourceImage?: string | null;
}

export interface SuggestionsResponse {
  suggestions: string[];
}

export interface SearchResult {
  personalized?: boolean;
  merchandisingBadge?: {kind:string;text:string;detail:string};
  color?: string;
  availableSizes?: string[];
  matchReasons?: string[];
  matchTier?: "primary" | "alternative";
  differences?: string[];
  productId: string;
  name: string;
  price: number | null;
  salePrice: number | null;
  currency: string;
  imageUrl?: string;
  productUrl?: string;
  availability?: string;
  category?: string | null;
  brand?: string | null;
  score?: number;
  aiVisual?: {
    provider: string;
    confidence: number | null;
    attributes: Record<string, string[]>;
  } | null;
}

export interface FacetValue {
  value: string;
  count: number;
}

export interface SearchResponse {
  queryId: string;
  correctedQuery?: string | null;
  processingTime: number;
  totalResults: number;
  detectedLanguage?: string;
  appliedFilters?: Record<string, string[] | string | number | boolean>;
  /** Fațetele lexicale: brandurile și categoriile care se potrivesc interogării. */
  suggestedFilters?: { brands?: FacetValue[]; categories?: FacetValue[] };
  results: SearchResult[];
}

export interface DiscoverTerm {
  term: string;
  count: number;
  source: string;
}

export interface DiscoverChip {
  label: string;
  query: string;
  count: number;
  kind: string;
}

export interface DiscoverGroupAudience {
  sizes?: string[];
  /** Forma din catalog: dama / barbati / copii. */
  key: string;
  count: number;
  /** Interogarea gata compusă pe care o trimite chipul: „sandale dama”. */
  query: string;
}

/** Un tip de produs („Sandale”) cu publicurile care chiar există la el. */
export interface DiscoverGroup {
  sizes?: string[];
  key: string;
  count: number;
  audiences: DiscoverGroupAudience[];
}

export interface DiscoverRecommendation extends SearchResult {
  discountPercent?: number | null;
  availableSizes?: string[];
}

/** Ce se afișează în dropdown înainte ca vizitatorul să tasteze. */
export interface DiscoverResponse {
  language: string;
  intent: string;
  popularSearches: DiscoverTerm[];
  recentSearches: DiscoverTerm[];
  personalizedFor?: string | null;
  personalized?: boolean;
  chips: DiscoverChip[];
  /** Ierarhia pe două niveluri. Lipsește la API-urile mai vechi, deci e opțională. */
  groups?: DiscoverGroup[];
  recommendations: DiscoverRecommendation[];
  generatedAt: string;
}

export type DiscoverIntent = "default" | "discount" | "season";

/** Dropdown-ul se cere o dată la focus și se ține minte cât ține și cache-ul serverului. */

export const DISCOVER_TTL_MS = 5 * 60 * 1000;
